export default {
  ONBOARDING_CREATE_BENEFICIARIES_REPOSITORY:
    Symbol.for('ONBOARDING_CREATE_BENEFICIARIES_REPOSITORY'),
  ONBOARDING_CREATE_BENEFICIARIES_COMMAND:
    Symbol.for('ONBOARDING_CREATE_BENEFICIARIES_COMMAND'),
};
